<template>
  <div>
    <Head title="Running Balance" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/running-balances">
          Running Balances
        </Link>
      </h1>
    </div>
    <div class="flex items-center justify-between mb-6">
      <a
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/skus/${sku.id}/running-balances-items/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
      <span class="text-gray-500 text-sm">Last updated: {{ data_as_at }}</span>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">UID</th>
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3">Category</th>
          <th class="pb-3 pt-3 px-3">Location</th>
          <th class="pb-3 pt-3 px-3">Stock Level</th>
          <th class="pb-3 pt-3 px-3">UoM</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3">Created At</th>
        </tr>
        <tr v-for="item in stocktakes.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.item_name }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.sku }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.category }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3" tabindex="-1">
              {{ item.location }}
            </span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 text-end justify-end" tabindex="-1">
              {{ item.quantity }}
            </span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 text-end justify-end" tabindex="-1">
              {{ item.uom }}
            </span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 text-end justify-end" tabindex="-1">
              {{ item.status }}
            </span>
          </td>
          <td class="w-px border-t pb-3 pt-3">
            <span class="flex items-end px-3 text-end justify-end" tabindex="-1">
              {{ item.created_at }}
            </span>
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="stocktakes.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchSingleDropdown from '@/Shared/SearchSingleDropdown'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    SearchSingleDropdown,
    Pagination,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    stocktakes: Object,
    data_as_at: String,
    locations: Object,
    sku: Object,
  },
  data() {
    return {
      form: {
        location: this.filters.location,
        category: this.filters.category,
      },
      show: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/running-balances', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    url() {
      let query = '';
      if (this.form.location) {
        query += `location=${this.form.location}`;
      }
      if (this.form.category) {
        if (query) {
          query += '&';
        }
        query += `category=${this.form.category}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
